'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
			logo: '=',
			headerText: '=',
			userName: '=',
			showDev: '=',
			section: '=',
			showIpAddress: '=',
			isLogin: '=',
		},
		templateUrl: `./${BUILD_PATH}/header-container.directive.html`,
		controller: /* @ngInject */ function ($scope, $mdSidenav, headerService) {
			$scope.SECTION_TYPES = headerService.SECTION_TYPES;
			$scope.toggle = headerService.toggleSidenav;

			init();

			function init(){
				if($scope.logo){
					headerService.setLogo($scope.logo);
				}
				if($scope.headerText){
					headerService.setHeaderText($scope.headerText);
				}
				if($scope.section){
					headerService.setSection($scope.section);
				}
			}

		}
	};
}
